<template>
	<div class="dbod">
		<div class="bbtitle">
			{{ info.stu_name }}的儿童康复训练档案({{ info.stu_disability }}){{ years1 }}年度
		</div>
		<div>
			<el-card id="id1">
				<div slot="header" class="clearfix">
					<span>基本资料信息</span>

				</div>
				<div>
					<el-descriptions title="基本信息" :column="4" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{ info.stu_name }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								身份证号
							</template>
							{{ info.stu_ID }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-location-outline"></i>
								性别
							</template>
							{{ info.stu_sex }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-tickets"></i>
								民族
							</template>
							{{ info.minzu }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-office-building"></i>
								出生日期
							</template>
							{{ shengri }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_height">
							<template slot="label">
								<i class="el-icon-office-building"></i>
								身高
							</template>
							{{ infov1?infov1.stu_height:"" }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_weight">
							<template slot="label">
								<i class="el-icon-office-building"></i>
								体重
							</template>
							{{ infov1.stu_weight?infov1.stu_weight:"" }}
						</el-descriptions-item>
					</el-descriptions>
					<!--基本信息结束-->
					<el-descriptions class="margin-top" title="残疾人证信息" :column="2" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item v-if="infov1&&infov1.stu_cjzheng">
							<template slot="label">
								<i class="el-icon-user"></i>
								残疾人证
							</template>
							{{ infov1.stu_cjzheng }}
						</el-descriptions-item>
						<el-descriptions-item  v-if="infov1&&infov1.stu_cjid">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								残疾人证号
							</template>
							{{ infov1.stu_cjid }}
						</el-descriptions-item>
					</el-descriptions>
					<!--残疾信息结束-->
					<el-descriptions class="margin-top" title="诊断信息" :column="3" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item v-if="infov1&&infov1.stu_org_name">
							<template slot="label">
								<i class="el-icon-user"></i>
								诊断机构
							</template>
							{{ infov1.stu_org_name }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_org_zdtime">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								诊断日期
							</template>
							{{ infov1.stu_org_zdtime }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_org_zdtime">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								诊断结果
							</template>
							{{ infov1.stu_org_result }}
						</el-descriptions-item>
					</el-descriptions>
					<!--诊断信息结束-->
					<el-descriptions class="margin-top" title="诊断评量结果" :column="3" size="" border>
						<template slot="extra" v-if="false">
							<el-button type="primary" size="small">操作</el-button>
						</template>
						<el-descriptions-item v-if="infov1&&infov1.stu_Cars_defen">
							<template slot="label">
								<i class="el-icon-user"></i>
								Cars
							</template>
							{{ infov1.stu_Cars_defen }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_MCHAT_defen">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								M-CHAT
							</template>
							{{ infov1.stu_MCHAT_defen }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_defen_ABC">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								ABC
							</template>
							{{ infov1.stu_defen_ABC }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_GESELL_defen">
							<template slot="label">
								<i class="el-icon-user"></i>
								GESELL
							</template>
							{{ infov1.stu_GESELL_defen }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_keshi_defen">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								克氏
							</template>
							{{ infov1.stu_keshi_defen }}
						</el-descriptions-item>
						<el-descriptions-item v-if="infov1&&infov1.stu_qitazhenduan">
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								其他
							</template>
							{{ infov1.stu_qitazhenduan }}
						</el-descriptions-item>
					</el-descriptions>
					<!--诊断评量信息结束-->
					<!-- <div class="el-descriptions__title margin-top">
						监护人信息
					</div> -->
					<el-table class="margin-top" :data="jianhurenLists" border style="width: 100%">
						<el-table-column prop="guanxi" label="关系" width="180">
						</el-table-column>
						<el-table-column prop="name" label="姓名" width="180">
						</el-table-column>
						<el-table-column prop="idcard" label="身份证号">
						</el-table-column>
						<el-table-column prop="phone" label="手机号">
						</el-table-column>
						<el-table-column prop="zhiye" label="职业">
						</el-table-column>
						<el-table-column prop="wenhua" label="文化程度">
						</el-table-column>
					</el-table>
				</div>

			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id2">
				<div slot="header" class="clearfix">
					<span>发展能力评估</span>

				</div>
				<div>
					<el-descriptions class="margin-top" title="诊断证明" :column="1" border>
						<el-descriptions-item>
							<template slot="label">
								诊断证明
							</template>
							<el-image :preview-src-list="srcList" fit="scale-down" style='width: 100px;'
								:src="srcList[0]"></el-image>
						</el-descriptions-item>
					</el-descriptions>
					<!--发展能力评估展示-->
					<div class="el-descriptions__title margin-top">
						评估内容
					</div>
					<!-- <div v-for="(p, i) in pinggucishu" :label="i + 1">

						<div class="margin-top">第{{ i + 1 }}次评估</div> -->

					<el-table :data="pingguLists" class="margin-top" border>
						<el-table-column label="领域" prop="lingyu"></el-table-column>
						<el-table-column label="得分" prop="defen"></el-table-column>
						<el-table-column label="优势" prop="youshi"></el-table-column>
						<el-table-column label="劣势" prop="lieshi"></el-table-column>
						<el-table-column label="评估人员" prop="ren"></el-table-column>
						<el-table-column label="备注" prop="beizhu"></el-table-column>
						<el-table-column label="评估序数" prop="cishu"></el-table-column>
					</el-table>
					<!-- </div> -->
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id3">
				<div slot="header" class="clearfix">
					<span>月计划</span>

				</div>
				<div>
					<div class="el-descriptions__title margin-top">
						年度目标
					</div>
					<div class="margin-top queren">
						<!-- <div>家长确认情况:</div>
						<div>{{ jiazhangneme }}</div>
						<div style="color: green;margin-right: 20px;margin-left: 3px;font-weight: bold;">
							{{ nianjiazhangv == 1 ? '已确认' : '未确认' }}</div> -->
						<div>代教老师：{{ nianjilu }}</div>
					</div>
					<el-table :data="mubiao" :span-method="objectSpanMethod" style="width: 100%; margin-top: 20px">
						<el-table-column prop="lingyu" label="领域" width="180">
						</el-table-column>
						<el-table-column prop="jieduan" label="目标阶段">
						</el-table-column>
						<el-table-column prop="shijian" label="起止时间">
						</el-table-column>
						<el-table-column prop="mubiao" label="训练目标">
						</el-table-column>
					</el-table>

					<div class="el-descriptions__title margin-top">
						月计划
					</div>
					<!--  v-if="b==0" -->
					<el-table :data="yueLists"  v-if="yueLists.length != 0">
						<el-table-column prop="month" label="月份" width="180">
						</el-table-column>
						<!-- <el-table-column v-for="(a, b) in yueKB" :key="b" :label="a.label"> -->
						<!-- {{yueLists[0].yueKBs[b].prop }} -->
						<el-table-column align="center" label="领域">
							<el-table-column v-for="(title, index) in yueLists[0].yueKBs" :key="index" :label="title.label">
								<template slot-scope="scope" >
									<!-- <span>{{scope.row.list[title].prop}}</span> -->
									<div v-if="scope.row.yueKBs[index]">
										<span >{{scope.row.yueKBs[index].prop}}</span>
									</div>
									
								</template>
							</el-table-column>

						</el-table-column>
						<!-- <el-table-column prop="yuejiazhang" label="监护人确认">
						</el-table-column> -->
						<el-table-column prop="name" label="老师">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<div style="height: 50px;width: 200px;"></div>

			<div style="height: 50px;width: 200px;"></div>
			<el-card id="id5">
				<div slot="header" class="clearfix">
					<span>家长培训记录</span>

				</div>
				<div>
					<el-table :data="jiazhang"  border>
						<el-table-column prop="month" label="日期">
						</el-table-column>
						<el-table-column prop="content" label="培训内容">
						</el-table-column>
						<el-table-column prop="qujian" label="时长">
						</el-table-column>
						<el-table-column prop="laoshi" label="授课老师">
						</el-table-column>
						<el-table-column label="照片资料补充">
      						<template slot-scope="scope">
       						 <el-button size="mini"  @click="seeimg(scope.$index, scope.row)">
								点击查看</el-button>
      						</template>
    					</el-table-column>
					</el-table>
				</div>
			</el-card>
			<el-card id="id6">
				<div slot="header" class="clearfix">
					<span>课程信息</span>

				</div>
				<div>
					<el-table :data="kecheng" >
						<el-table-column prop="week_ke" label="上课周次">
						</el-table-column>
						<el-table-column prop="curriculum_name" label="课程名称">
						</el-table-column>
						<el-table-column prop="curriculum_classification" label="课程分类">
						</el-table-column>
						<el-table-column prop="curriculum_teacher" label="授课老师">
						</el-table-column>
						<el-table-column  prop="start_time" label="上课开始时间">
    					</el-table-column>
						<el-table-column  prop="end_time" label="上课结束时间">
    					</el-table-column>
						<el-table-column  prop="org_name" label="所在机构">
    					</el-table-column>
					</el-table>
				</div>
			</el-card>
			<div style="width: 200px;"></div>
			<el-card id="id4">
				<div slot="header" class="clearfix">
					<span>日记录</span>
				</div>
				<div style="display: flex;flex-direction: row;">
					<el-button @click="bbtype = 0" size="mini" type="primary">日历速览</el-button>
					<el-button @click="bbtype = 1" size="mini" type="primary">阶段详细</el-button>
				</div>

				<div v-if="bbtype == 0" v-loading="tanchuang">
					
					<el-calendar ref="calendar" v-model="nianv1" v-prev-month-btn>
						<template slot="dateCell" slot-scope="{date, data}">
							<div @click="djday(date, data)" style="width: 100%;display: flex;flex-direction: column;">
								<p style="margin-bottom: 0px;padding-bottom: 0px;">
									{{ data.day.split('-').slice(1).join('-') }}
									<span v-if="riLists.findIndex(x => { return x.day == data.day }) >= 0"
										style="color: green;">✔</span> ️
								</p>
								<p style="margin-top: 10px;padding-top: 0px;color: green;font-size: 80%;"
									v-if="riLists.findIndex(x => { return x.day == data.day && x.isclock }) >= 0">
									{{ riLists.find(x => x.day == data.day && x.isclock).type }}
								</p>
							</div>
						</template>
					</el-calendar>
				</div>
				<div v-if="bbtype == 1"  v-loading="tanchuang">
					

					<div class="block"
						style="margin-top: 5px;margin-bottom: 10px; display: flex;flex-direction: row;justify-content: space-around;align-items: center;">
						<span class="demonstration" style="margin-right: 5px;">请选择起始时间</span>
						<div class="block">
							<el-date-picker v-model="statime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
								{{ statime }}
							</el-date-picker>
						</div>
						<div>至</div>
						<div class="block">
							<el-date-picker v-model="endtime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
								{{ endtime }}
							</el-date-picker>
						</div>
						<el-button @click="chaxun" size="mini" type="primary">查询</el-button>
					</div>
					<el-table :data="daytime" v-if="daytime.length != 0">
						<el-table-column prop="month" label="日期" width="100" style="height: 100%;">
						</el-table-column>
						<el-table-column align="center" label="领域">

							<el-table-column v-for="(title, index) in daytime[0].yueKBs" :key="index" :label="title.label">
								<template slot-scope="scope">
									<div
										style=" display: flex;flex-direction: column;justify-content: space-between;align-items: center;">
										<div style="display: flex;flex-direction: column;align-items: center;"><el-button
												size="mini" type="primary">训练内容</el-button> <span v-if="scope.row.yueKBs[index]">{{scope.row.yueKBs[index].prop }}</span></div>
										<div
											style="margin-top: 10px;display: flex;flex-direction: column;align-items: center;">
											<el-button size="mini" type="warning">完成情况</el-button> <span v-if="scope.row.yueKBs[index]"> {{
												scope.row.yueKBs[index].props }}</span>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<!-- <el-table-column prop="yuejiazhang" label="监护人确认">
						</el-table-column> -->
						<el-table-column prop="name" label="老师">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
		</div>
		<div class="rbuttong">
			<el-date-picker v-model="years" type="year" class="rbtn" style="width: 10vw;" format="yyyy"
				@change="handleYearChange" :picker-options="pickerOptions">
			</el-date-picker>
			<el-button @click="scrollT('id1')" class="rbtn">基本资料信息</el-button>
			<el-button @click="scrollT('id2')" style="margin-left: 0px;" class="rbtn">发展能力评估</el-button>
			<el-button @click="scrollT('id3')" style="margin-left: 0px;" class="rbtn">月计划</el-button>
			<el-button @click="scrollT('id5')" style="margin-left: 0px;" class="rbtn">家长培训记录</el-button>
			<el-button @click="scrollT('id6')" style="margin-left: 0px;" class="rbtn">课程信息</el-button>
			<el-button @click="scrollT('id4')" style="margin-left: 0px;" class="rbtn">周记录</el-button>

		</div>
		<el-dialog title="提示" :visible.sync="dialogVisiblev1" width="30%" :before-close="handleClose11">
			<span>点击可放大查看</span><div style="margin-left: 10px;"></div>
			<div class="demo-image__preview">
				<el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="imgList">
				</el-image>
				1/{{imgList.length}}
			</div>
			<el-button @click="dialogVisiblev1 = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisiblev1 = false">确 定</el-button>
		</el-dialog>
		<el-dialog :title="selected.day + '日记录'" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<el-descriptions class="margin-top" :column="1" border v-if="selected.content">
				<el-descriptions-item v-for="(p, i) in selected.content" :key="i">
					<template slot="label">
						{{ p.type }}
					</template>
					<div style="display: flex;justify-content: space-between;">
						<div>{{ p.neirong }}</div>
						<div style="margin-right: 20px;color: green;font-weight: bold;">完成情况:{{ p.score }}</div>
					</div>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						教师
					</template>
					{{ selected.teacher }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						考勤情况
					</template>
					{{ selected.type }}
				</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 家长培训照片弹窗
			dialogVisiblev1: false,
			zhili:['感知觉','生活自理','社会交往','认知','语言沟通','精细动作','粗大运动'],
			gudu:['感知觉','生活自理','社会交往','认知','语言沟通','精细动作','粗大运动','情绪与行为'],
			url:'',
			imgList:[],
			nianv1:'',
			//阶段时间
			statime: '',
			endtime: '',
			//日记录切换
			bbtype: 0,
			// 接收学生基本信息
			info: [],
			// 接收学生详细信息
			infov1: [],

			// 诊断证明
			srcList: [],
			//假定学生id
			stu_id: '',
			//日记录详情
			content: [],
			//日记录显示
			huoqunyv1: 1,
			//家长确认消息
			nianjiazhangv: 0,
			//家长姓名
			jiazhangneme: '',
			nianjilu: '',
			shengri: '',
			dialogVisible: false,
			//监护人信息数据
			jianhurenLists: [],
			//评估索引 第几次
			pingguIndex: 1,
			//评估统计
			pinggucishu: '',
			//评估数据
			pingguLists: [],
			//日记录月份
			dataday: new Date(),
			//年度目标数据
			mubiao: [],
			//月计划月份
			yue1: [],
			yue2: [],
			yuejiazhang: 0,
			//月计划可变领域
			yueKB: [],
			yueLists: [],
			//模拟下签到情况
			//正常content应该是点击某一个再请求比较合适
			//目前先用签到模式 以后补一个列表模式
			riLists: [],
			selected: {},
			jiazhang: [],
			kecheng:[],
			// loading
			tanchuang: false,
			years: '',
			years1: null,
			pickerOptions: {
				disabledDate(time) {
					return time.getFullYear() > new Date().getFullYear(); // 禁止选择未来的年份
				},
			},
			daytime: [],
			daykb: [],
		}
	},
	directives: {
  		prevMonthBtn: {
    		inserted(el, binding, vnode) {
     		 const vm = vnode.context; // 保存外部的this引用
     		 el.addEventListener('click', () => {
      		  	const calendarComponent = vm.$refs.calendar;
       				let bb = calendarComponent.selectedDay.slice(0, 7);
					let aa = calendarComponent.selectedDay.split("-")[0];
					console.log(aa,"aa");
				 if(aa!=vm.years){
					vm.tanchuang=true
					vm.getdaylistv1(bb)
				   }
     			 });
  	  		},
 		 },
		},
	computed:{
       teatoken(){
			return window.localStorage.getItem("tea_token");
		},
	},
	watch: {
		pingguIndex: {
			async handler() {
				this.pingguLists = []
				let res = await axios.get(this.$urls + 'canlian/chafznl', {
					params: {
						stu_id: this.stu_id,
						datas: this.pingguIndex
					},headers: {
					"teatoken": this.teatoken
				}
				});
				res.data.map(async p => {
					this.pingguLists.push({
						lingyu: p.Area_Name,
						defen: p.score,
						youshi: p.advantage,
						lieshi: p.disadvantage,
						ren: p.Evaluators,
						beizhu: p.remark
					});
				});
				this.tanchuang = false
			}
		},
		years1: {
			 handler() {
			 		this.shuaxun()
				
			},
		}
	},
	methods: {
		handleClose11(){
			this.dialogVisiblev1=false
		},
		seeimg(e,a){
			if(a.ptr_img!="null"||a.ptr_img.length!=0){
				this.dialogVisiblev1=true
				this.imgList=[]
				this.url=this.jiazhang[e].ptr_img[0]
				for(let a =0;a<this.jiazhang[e].ptr_img.length;a++){
					this.imgList.push(this.jiazhang[e].ptr_img[a])
				}
			}else{
				
			}
			
		},
		shuaxun() {
			this.srcList = []
			this.content = []
			this.huoqunyv1 = 1
			this.nianjiazhangv = 0
			this.jiazhangneme = ''
			this.nianjilu = ''
			this.shengri = ''
			this.jianhurenLists = []
			this.pingguIndex = 1
			this.pinggucishu = ''
			this.pingguLists = []
			this.mubiao = []
			this.yue1 = []
			this.yue2 = []
			this.yuejiazhang = 0
			this.yueKB = []
			this.yueLists = []
			this.riLists = []
			this.jiazhang = []
			this.kecheng = []
			this.daytime = []
			this.daykb = []
			//获取监护人信息数据
			this.getjianhurenLists();
				//获取评估信息数据
					this.getpingguLists();
				//获取年度数据
					this.getnianduLists();
				//获取月记录
					this.getyuelists()
				//获取日记录
					this.getdaylist()
				//家长培训记录
					this.getjiazhangpeixun()
				//学生课程记录
					this.getkecheng()
		},
		async getkecheng(){
			let res = await axios.get(this.$urls + 'mubiao_y/stu_class_info', {
				params: {
					qx:'"all"',
              		stu_id:this.stu_id,
              		year:this.years1
				},headers: {
					"teatoken": this.teatoken
				}
			});
			this.kecheng=res.data.cha
			
		},
		handleYearChange(year) {
			this.years.setFullYear(year.getFullYear());
			this.nianv1=year
			this.years1 = year.getFullYear()
		},
		//时间段查询
		async chaxun() {
			this.tanchuang = true
			let aa = []
			let res = await axios.get(this.$urls + 'canlian/jieduan', {
				params: {
					stu_id: this.stu_id,
					statime: this.statime,
					endtime: this.endtime
				},headers: {
					"teatoken": this.teatoken
				}
			});

			let l=[];
			res.data.map(p=>{
              if(l.indexOf(p.Area_Name)==-1){
				l.push(p.Area_Name)
			  };
			});
			this.tanchuang = false
			if (res.data.length == 0) {
				this.openv1()
			} else {
				
				if (res.data.length != 0) {
					this.daytime = []
					for (let l = 0; l < res.data.length; l++) {
						// if (res.data[l].jiazhang == 0) {
						// 	this.daytime.push({
						// 		month: res.data[l].data,
						// 		yueKBs: [],
						// 		yuejiazhang: '家长未确认',
						// 		name: res.data[l].name,
						// 	})
						// } else if (res.data[l].jiazhang == 1) {
						// 	this.daytime.push({
						// 		month: res.data[l].data,
						// 		yueKBs: [],
						// 		yuejiazhang: '家长已确认',
						// 		name: res.data[l].name,
						// 	})
						// } else {
							this.daytime.push({
								month: res.data[l].data,
								yueKBs: [],
								// yuejiazhang: '等待家长确认',
								name: res.data[l].name,


							})
						// }
					}
					
					for (let i = 0; i < this.daytime.length; i++) {
						for (let s = 0; s < res.data.length; s++) {
							if (this.daytime[i].month == res.data[s].data) {
								if (res.data[s].Completion == "请选择") {
									this.daytime[i].yueKBs.push({
										label: res.data[s].Area_Name,
										prop: res.data[s].content,
										props: ''
									})
								} else {
									this.daytime[i].yueKBs.push({
										label: res.data[s].Area_Name,
										prop: res.data[s].content,
										props: res.data[s].Completion
									})
								}
							}
						}
					}
					// 时间去重
					for (let s = 0; s < this.daytime.length; s++) {
						for (let h = s + 1; h < this.daytime.length; h++) {
							if (this.daytime[s].month == this.daytime[h].month) {
								this.daytime.splice(h, 1);
								h--;
							}
						}
					}
					// 领域去重
					for (let s = 0; s < this.daytime.length; s++) {

						for (let ss = 0; ss < this.daytime[s].yueKBs.length; ss++) {
							
								for (let h = ss + 1; h < this.daytime[s].yueKBs.length; h++) {
									if (this.daytime[s].yueKBs[ss].label == this.daytime[s].yueKBs[h].label) {
										this.daytime[s].yueKBs.splice(h, 1);
										h--;
									}
								}
							
						}
					}
					console.log(this.daytime,"this.daytimethis.daytime");
					
				} else {

				}
				// 	
			}

			console.log(this.daytime, "aaaa22222222222222");
		},
		//详细日记录为空的提醒
		openv1() {
			this.$alert('所选时间段暂无记录', {
				confirmButtonText: '确定',
				callback: action => {
				}
			});
		},
		//滑动
		scrollT(ID) {
			setTimeout(() => {
				let ys = document.getElementById(ID);
				ys.scrollIntoView();
			}, 20)

		},

		handleClose(done) {
			done();
		},
		//模拟获取监护人信息数据
		async getjianhurenLists() {
			let ans = await axios.get(this.$urls + 'canlian/xsjbzlchav1', {
				params: {
					stu_id: this.stu_id,
					year: this.years1,
				},headers: {
					"teatoken": this.teatoken
				}
			});
			console.log(ans.data,"ans.data");
			this.info = ans.data[0]
			for (const key in this.info) {
				if (this.info[key] == "undefined") {
					this.info[key] = "暂无数据"
				}
			}
			console.log(ans.data,"ans.data01");
			let a = ans.data[0].stu_disability.split('')
			console.log(a,"ans.data02");
			for (let ww = 0; ww < a.length; ww++) {
				if (a[ww] == ",") {
					a.splice(ww, 1)
					this.info.stu_disability = ""
					for (let b = 0; b < a.length; b++) {
						this.info.stu_disability += a[b]
					}
				}
			}
			console.log(ans.data,"ans.data03");
			console.log(this.info.stu_zd_img,"ans.data03");
			// if (this.info.stu_zd_img.length != 0 && this.info.stu_zd_img.length !=null) {
			// 	let li = JSON.parse(this.info.stu_zd_img)
			// 	for (let i in li) {
			// 		this.srcList.push(this.$urls + li[i])
			// 	}
			// }
			let lll = ans.data[0].stu_ID.substr(16, 1)
				if (lll % 2 == 0) {
					this.info.stu_sex = "女"
				} else {
					this.info.stu_sex = "男"
				}
			console.log(this.srcList,"this.srcListthis.srcListthis.srcList");
				
			
			let l = ans.data[0].stu_ID.substring(6, 10)
			let i = ans.data[0].stu_ID.substring(10, 12)
			let s = ans.data[0].stu_ID.substring(12, 14)
			this.shengri = l + "-" + i + "-" + s
			let anss = await axios.get(this.$urls + 'canlian/xsjbzlchav2', {
				params: {
					stu_id: this.stu_id,
					//缺个year
					
				},headers: {
					"teatoken": this.teatoken
				}
			});
			console.log(ans.data,"ans.datassssssss");
			this.infov1 = anss.data[0]
			for (const key in this.infov1) {
				if (this.infov1[key] == "undefined" || this.infov1[key] == "") {
					this.infov1[key] = "暂无数据"
				}
			}
			if(this.infov1){
				this.jiazhangneme = this.infov1.stu_faname
			}else{
				this.infov1={};
			}
			
			let lists = [{
				guanxi: "父亲",
				name: this.infov1.stu_faname,
				idcard: this.infov1.stu_faid,
				phone: this.infov1.stu_faphone,
				zhiye: this.infov1.stu_fawork,
				wenhua: this.infov1.stu_fawenhua
			}, {
				guanxi: "母亲",
				name: this.infov1.stu_maname,
				idcard: this.infov1.stu_maid,
				phone: this.infov1.stu_maphone,
				zhiye: this.infov1.stu_mawork,
				wenhua: this.infov1.stu_mawenhua
			}];
			this.jianhurenLists = lists;
			
		},

		//模拟获取评估数据
		async getpingguLists() {
			this.pinggucishu=[]
			let res = await axios.get(this.$urls + 'canlian/chafznlv1', {
				params: {
					stu_id: this.stu_id,
					years: this.years1
				},headers: {
					"teatoken": this.teatoken
				}
			});
			let pingguce = []
			for (let l = 0; l < res.data.length; l++) {
				pingguce.push(res.data[l].Frequency)
			}
			for (let s = 0; s < pingguce.length; s++) {
				for (let h = s + 1; h < pingguce.length; h++) {
					if (pingguce[s] == pingguce[h]) {
						pingguce.splice(h, 1);
						h--;
					}
				}
			}
			let a = 0;

			pingguce.forEach((item3, index3) => {
				for (let b = 0; b < pingguce.length - index3; b++) {
					if (pingguce[b] > pingguce[b + 1]) {
						a = pingguce[b];
						pingguce[b] = pingguce[b + 1];
						pingguce[b + 1] = a;
					}
				}
			})
			this.pinggucishu = pingguce
			res.data.map(async p => {
				this.pingguLists.push({
					lingyu: p.Area_Name,
					defen: p.score,
					youshi: p.advantage,
					lieshi: p.disadvantage,
					ren: p.Evaluators,
					beizhu: p.remark,
					cishu: p.Frequency
				});
			});

		},
		//合并年度数据表头
		objectSpanMethod({
			row,
			column,
			rowIndex,
			columnIndex
		   }) {
			if (columnIndex === 0) {
				if (rowIndex % 3 === 0) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},

		//模拟年度目标数据
		async getnianduLists() {
			let res = await axios.get(this.$urls + 'canlian/xqmbcha1', {
				params: {
					stu_id: this.stu_id,
					years: this.years1,
				},headers: {
					"teatoken": this.teatoken
				}
			});
			// console.log(res.data, 'nianianiani');
			// res.data.map(async p => {
			// 	this.mubiao.push({
			// 		lingyu: p.Area_Name,
			// 		jieduan: '学年目标',
			// 		jieduanlist: [
			// 			{
			// 				jieduan_shijian: p.Zong_startend.substring(0, 10) + "至" + p.Zong_startend.substring(10, 20),

			// 			}, {
			// 				jieduan_mubiao: p.zong,
			// 			}
			// 		],
			// 		jieduana: '第一学期',
			// 		jieduanalist: [{
			// 			jieduana_shijian: p.First_startend.substring(0, 10) + "至" + p.First_startend.substring(10, 20),

			// 		}
			// 			, {
			// 			jieduana_mubiao: p.First,
			// 		}],
			// 		jieduanb: '第二学期',

			// 		jieduanblist: [{
			// 			jieduanb_shijian: p.Second_startend.substring(0, 10) + "至" + p.Second_startend.substring(10, 20),

			// 		},
			// 		{
			// 			jieduanb_mubiao: p.Second
			// 		}]

			// 	});

			// });
			// this.dealTable()
			this.nianjilu = res.data[0].name
			res.data.map(async p => {
				this.mubiao.push({
					lingyu: p.Area_Name,
					jieduan: '学年目标',
					shijian: p.Zong_startend.substring(0, 10) + "至" + p.Zong_startend.substring(10, 20),
					mubiao: p.zong

				},
					{
						lingyu: p.Area_Name,
						jieduan: '第一学期',
						shijian: p.First_startend.substring(0, 10) + "至" + p.First_startend.substring(10, 20),
						mubiao: p.First,
					},
					{
						lingyu: p.Area_Name,
						jieduan: '第二学期',
						shijian: p.Second_startend.substring(0, 10) + "至" + p.Second_startend.substring(10, 20),
						mubiao: p.Second
					}

				);

			});
			// let niandu = [{
			// 	lingyu: '感知觉',
			// 	jieduan: '学年目标',
			// 	shijian: '2023-01-01 至2023-12-31',
			// 	mubiao: '对准目标工作如套被套，听从简单口语指令追视一个方向移动的物体'
			// }, {
			// 	lingyu: '感知觉',
			// 	jieduan: '学年目标',
			// 	shijian: '2023-01-01 至2023-12-31',
			// 	mubiao: '对准目标工作如套被套，听从简单口语指令追视一个方向移动的物体'
			// }, {
			// 	lingyu: '感知觉',
			// 	jieduan: '学年目标',
			// 	shijian: '2023-01-01 至2023-12-31',
			// 	mubiao: '对准目标工作如套被套，听从简单口语指令追视一个方向移动的物体'
			// }, {
			// 	lingyu: '感知觉',
			// 	jieduan: '学年目标',
			// 	shijian: '2023-01-01 至2023-12-31',
			// 	mubiao: '对准目标工作如套被套，听从简单口语指令追视一个方向移动的物体'
			// }, {
			// 	lingyu: '感知觉',
			// 	jieduan: '学年目标',
			// 	shijian: '2023-01-01 至2023-12-31',
			// 	mubiao: '对准目标工作如套被套，听从简单口语指令追视一个方向移动的物体'
			// }, {
			// 	lingyu: '感知觉',
			// 	jieduan: '学年目标',
			// 	shijian: '2023-01-01 至2023-12-31',
			// 	mubiao: '对准目标工作如套被套，听从简单口语指令追视一个方向移动的物体'
			// }];
			// this.mubiao = niandu
		},

		// 处理表格数据
		dealTable() {
			let getDate = [] // 存储新表格数据
			let typeIndex = [0] // 保存id,地区需要合并的值
			let nameIndex = [0] // 保存类型需要合并的值
			let a // id,地区需要合并的行是所有类型的长度
			this.mubiao.forEach((v, index) => {
				if (v.type && v.type.length) {
					a = 0
					v.type.forEach((subV, i, typeData) => {
						if (subV.sortList && subV.sortList.length) {
							subV.sortList.forEach((ss, k, data) => {
								if (k === data.length - 1) {
									typeIndex.push(data.length) // 把每一个类型下面数据长度存起来
									a += data.length // 把所有类型下面的数据长度相加
									if (i === typeData.length - 1) {
										nameIndex.push(a) // 类型循环完成后把数据长度存起来
									}
								}
								getDate.push({
									id: v.id,
									region: v.region,
									type: subV.sortName,
									name: ss.name
								})
							})
						}
					})
				}
			})

			// console.log(nameIndex)
			// [0, 5, 4]
			// 看一下打印出来的规律,除去第一项,5是第一次需要合并的行
			// 第二次合并又是从第五行开始合并4行

			// console.log(typeIndex)
			// [0, 2, 3, 2, 2]
			// 类型的数据存储规律也是一样,第一次合并2行
			// 第二次从2行开始,合并3行,以此类推

			// 根据这个规则,只需要给数据加上两个额外的属性控制是否合并就OK
			let k = 0
			let t = 0
			nameIndex.forEach((v, i, nameArr) => {
				if (nameArr[i + 1]) {
					getDate[k].nameIndex = nameArr[i + 1]
					k += nameArr[i + 1]
				}
			})

			typeIndex.forEach((v, i, typeArr) => {
				if (typeArr[i + 1]) {
					getDate[t].typeIndex = typeArr[i + 1]
					t += typeArr[i + 1]
				}
			})
			this.tableData6 = getDate
		},

		//日记录数据请求
		async getdaylistv1(aa) {
		  
		  let res = await axios.get(this.$urls + 'canlian/kstjcha', {
			params: {
			  stu_id: this.stu_id,
			  day: aa
			},headers: {
				"teatoken": this.teatoken
			}
		  });
		  
		  let a = res.data.jj
		  if (a.length != 0) {
				for (let i = 0; i < a.length; i++) {
					// console.log("963963");
					this.riLists.push({
						day: a[i].riqi_ke,
						teacher: a[i].teacher_ke,
						type: a[i].dcs_class,
						isclock: true,
						content: this.content
					})

				}this.tanchuang=false
			}else{
				this.tanchuang=false
			}
		},

		//日记录数据请求
		async getdaylist() {
			var da = this.years1
			let res = await axios.get(this.$urls + 'canlian/kstjcha', {
				params: {
					stu_id: this.stu_id,
					day: da
				},headers: {
					"teatoken": this.teatoken
				}
			});
			let a = res.data.jj
			if (a.length != 0) {
				for (let i = 0; i < a.length; i++) {
					this.riLists.push({
						day: a[i].riqi_ke,
						teacher: a[i].teacher_ke,
						type: a[i].dcs_class,
						isclock: true,
						content: this.content
					})

				}this.tanchuang=false
			}else{this.tanchuang=false}
			// console.log(this.riLists,'this.riLists');

		},

		//点击日历执行的事件
		async djday(date, data) {
			this.tanchuang = true
			let res = await axios.get(this.$urls + 'canlian/rjlcha', {
				params: {
					stu_id: this.stu_id,
					day: data.day
				},headers: {
					"teatoken": this.teatoken
				}
			});
			if (res.data.length != 0) {
				for (let i in res.data) {
					this.content.push({
						type: res.data[i].Area_Name,
						neirong: res.data[i].content,
						score: res.data[i].Completion
					})
				}
				this.tanchuang = false
			} else {
				this.open()
				this.tanchuang = false
			}
			let a = this.riLists.find(x => {
				return x.day == data.day
			});
			if (a) {
				this.dialogVisible = true;
				this.selected = a;
				this.content = []
			} else {
				this.open2()
			}



		},

		//提醒弹窗'该日还未填入数据'
		open() {
			this.$alert('该日还未填入数据', {
				confirmButtonText: '确定',
				callback: action => {
				}
			});
		},

		//提醒弹窗2'该日并没有考勤'
		open2() {
			this.$alert('该日并没有考勤', {
				confirmButtonText: '确定',
				callback: action => {
				}
			});
		},

		//月记录数据请求
		async getyuelists() {
			let res = await axios.get(this.$urls + 'canlian/ymbcha', {
				params: {
					stu_id: this.stu_id,
					year: this.years1,
				},headers: {
					"teatoken": this.teatoken
				}
			});
			if (res.data.length != 0) {
				for (let l = 0; l < res.data.length; l++) {
					if (res.data[l].jiazhang == 0) {
						this.yueLists.push({
							month: res.data[l].Start_end,
							yueKBs: [],
							yuejiazhang: '家长未确认',
							name: res.data[l].name
						})

					} else if (res.data[l].jiazhang == 1) {
						this.yueLists.push({
							month: res.data[l].Start_end,
							yueKBs: [],
							yuejiazhang: '家长已确认',
							name: res.data[l].name
						})
					} else {
						this.yueLists.push({
							month: res.data[l].Start_end,
							yueKBs: [],
							yuejiazhang: '等待家长确认',
							name: res.data[l].name
						})
					}
				}
				for (let s = 0; s < this.yueLists.length; s++) {
					for (let h = s + 1; h < this.yueLists.length; h++) {
						if (this.yueLists[s].month == this.yueLists[h].month) {
							this.yueLists.splice(h, 1);
							h--;
						}
					}
				}
				
				for (let i = 0; i < this.yueLists.length; i++) {
					for (let s = 0; s < res.data.length; s++) {
						if (this.yueLists[i].month == res.data[s].Start_end) {
							if(res.data[s].target.length!=0){
								this.yueLists[i].yueKBs.push({
								label: res.data[s].Area_Name,
								prop: res.data[s].target
							})
							}else{
								this.yueLists[i].yueKBs.push({
								label: res.data[s].Area_Name,
								prop: '暂无数据'
							})
							}
							
						}
					}
				}
				console.log(this.yueLists, " this.yueLists02");
				for (let bb = 0; bb < this.yueLists[0].yueKBs.length; bb++) {
					this.yueKB.push({
						label: this.yueLists[0].yueKBs[bb].label
					})
				}
			} else {

			}
		},

		//家长培训记录
		async getjiazhangpeixun() {
			let res = await axios.get(this.$urls + 'canlian/jzpxcha', {
				params: {
					stu_id: this.stu_id,
					year: this.years1,
				},headers: {
					"teatoken": this.teatoken
				}
			});
			if (res.data.length != 0) {
				res.data.map(async p => {
					if(p.ptr_img!="null"||p.ptr_img.length!=0){
					    try{
							p.ptr_img=JSON.parse(p.ptr_img)
						for(let pp =0;pp<p.ptr_img.length;pp++){
							p.ptr_img[pp]=this.$urls+ p.ptr_img[pp]
                  		}
						}catch(e){
							p.ptr_img=[];
						}
					}else{
						p.ptr_img=[]
					}
					this.jiazhang.push({
						month: p.date,
						content: p.ptr_name,
						qujian: p.Duration + "min",
						laoshi: p.Teacher,
						ptr_img:p.ptr_img
					});
				});
			}
		}

	},
	created() {
		this.years = new Date(this.$route.query.year);
		this.years1 = this.years.getFullYear()
		this.nianv1 = this.years
		console.log(this.years1,"this.years1");
		//传参获取学生id 档案  this.$route.query.id
		this.stu_id = this.$route.query.stuid; 
		// //获取监护人信息数据
		// this.getjianhurenLists();
		// //获取评估信息数据
		// this.getpingguLists();
		// //获取年度数据
		// this.getnianduLists();
		// //获取月记录
		// this.getyuelists()
		// //获取日记录
		// this.getdaylist()
		// //家长培训记录
		// this.getjiazhangpeixun()
	},

}
</script>

<style>
.queren {
	display: flex;
	align-items: center;
}

.margin-top {
	margin-top: 15px;
}

.dbod {
	width: 80vw;
	margin-left: 5vw;
}

.bbtitle {
	text-align: center;
	font-weight: bold;
	font-size: 30px;
	padding: 15px 15px;
}

.rbuttong {
	position: fixed;
	right: 5px;
	width: 12vw;
	top: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.rbtn {
	width: 10vw;
	margin-top: 10px;
	margin-left: 0px;
}
</style>